import styles from "../styles/addInvoice.module.css";

export default function InvoiceFooter({
  onSubmit,
  resetFields,
  saving = false,
}) {
  return (
    <div className={styles["invoice-footer"]}>
      <div className={styles.actions}>
        <button
          type="button"
          className={`${styles.btn} ${styles["btn-clean-form"]}`}
          onClick={resetFields}
          disabled={saving}
        >
          <i className="fa-solid fa-repeat"></i> Limpiar Formulario
        </button>

        <button
          type="button"
          className={`${styles.btn} ${styles["btn-save"]}`}
          onClick={onSubmit}
          disabled={saving}
          style={{ opacity: saving ? 0.7 : 1 }}
        >
          {saving ? (
            <>
              <i className="fa-solid fa-spinner fa-spin"></i> Guardando…
            </>
          ) : (
            <>
              <i className="fa-solid fa-save"></i> Guardar Factura
            </>
          )}
        </button>
      </div>
    </div>
  );
}
